import { Form } from '../core'

$.fn.CollaboratorForm = function() {
  let self = this
  self.form = undefined

  self.initialize_form = function() {
    self.form = new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('.header').outerHeight(false) + 20,
      locale: saintlo_l10n.LOCALE,
      onSuccess: function() {
        let $success = $('<p class="form-success form-success--groups">')
        $success.html(saintlo_l10n.BLOG_SUCCESS).hide()
        let targetTop = self.closest('.row').offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 80)
        self.after($success)
        self.fadeOut(250, function() {
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
          $success.fadeIn(250)
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('collaborator-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
